(ns practitest.frontend.dashboards-settings.subs
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.dashboards-settings.events :as events]))

(re-frame/reg-sub
 ::state
 (fn [db _]
   (get db events/db-key)))

(re-frame/reg-sub
 ::field
 :<- [::state]
 (fn [state [_ k]]
   (get state k)))

(re-frame/reg-sub
 ::visible-tabs
 :<- [::state]
 (fn [{:keys [tabs show-archived?]} _]
   (if show-archived?
     (concat (remove :archived tabs) (filter :archived tabs))
     (remove :archived tabs))))

(re-frame/reg-sub
 ::unarchived-count
 :<- [::state]
 (fn [{:keys [tabs]} _]
   (count (remove :archived tabs))))

(re-frame/reg-sub
 ::archived-count
 :<- [::state]
 (fn [{:keys [tabs]} _]
   (count (filter :archived tabs))))
